export const awaiter = (timeout = 10) =>
  new Promise((resolve) => setTimeout(resolve, timeout));
